export interface SupplierA11yInput {
  uuid: string;
  hasRating?: boolean;
  hasPrice?: boolean;
  respondsQuickly?: boolean;
}

export interface SupplierA11yConfig {
  baseId: string;
  headingId: string;
  ratingId: string;
  priceId: string;
  quickId: string;
  labelledBy: string;
}

/**
 * Build all IDs and the aria-labelledby string for a supplier card.
 */
export function getSupplierA11y({
  uuid,
  hasRating = false,
  hasPrice = false,
  respondsQuickly = false,
}: SupplierA11yInput): SupplierA11yConfig {
  const baseId = `supplier-${uuid}`;
  const headingId = `${baseId}-heading`;
  const ratingId = `${baseId}-rating`;
  const priceId = `${baseId}-price`;
  const quickId = `${baseId}-quick`;

  const parts: string[] = [headingId];
  if (respondsQuickly) parts.push(quickId);
  if (hasRating) parts.push(ratingId);
  if (hasPrice) parts.push(priceId);

  return {
    baseId,
    headingId,
    ratingId,
    priceId,
    quickId,
    labelledBy: parts.join(' '),
  };
}
